import Component from './component';

export interface Props {
    html: string;
    className?: string;
}

Component.defaultProps = {
    className: null,
};

export default Component;
